// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xFviv_vebUwbGP {
  position: relative;
  flex-grow: 1;
  overflow-y: auto;
  outline: none;
}
.cqLXKslPmYkovq {
  display: none;
}
`, ""]);
// Exports
export var content = `xFviv_vebUwbGP`;
export var hidden = `cqLXKslPmYkovq`;
export default ___CSS_LOADER_EXPORT___;
